import { styled } from 'styled-components';

import { Media } from '../../../../../theme/Media.tsx';

export const TableHeadWrapper = styled.thead`
  @media ${Media.smMin} {
    th {
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
    }
  }
`;

export const TableHeadRowWrapper = styled.tr`
  background: ${({ theme }) => theme.colors.grey01_1};
  height: 100%;

  @media ${Media.xsMax} {
    background: transparent;
  }
`;
